module.exports = __webpack_public_path__ + "img/c4a9703.jpg";